module.exports = __webpack_public_path__ + "media/images/bnr_header_newplan_pc-823c1c7d11cc38b06bd86d73d0a3dfe5.jpg";